

import CheckoutItem from './components/common/CheckoutItem';

import useTranslations from "../providers/useTranslations";
import { CartContext } from '../providers/CartContext';
import { BusinessContext } from '../providers/BusinessContext';
import { useUser } from '../providers/UserContext';
import { uuidv4, formatPrice } from '../lib/utils'

import OrderProgress from './order/order_progress'
import { DisplayAddressCard } from './components/common/AddressCard'

function Thanks(props) {

  const { business, menu, checkoutData, setStage } = props

  const [orderSubmitted, setOrderSubmitted] =React.useState(false)
  const [deliveryChargeRange, setChargeRange] =React.useState(null)
  const [deliveryPrice, setDeliveryPrice] =React.useState(null)
  const [deliverType, setDeliverType] =React.useState(null)
  const [deliveryData, setDeliveryData] =React.useState(null)

  const [packingCost, setPackingCost] =React.useState(null)
  const [totalWithDelivery, setTotalWithDelivery] =React.useState(true)

  const [paymentMethod, setPaymentMethod] =React.useState('Cash')
  const [methodData, SetMethodData] =React.useState(null)
  const [bankName, setBankName] =React.useState(null)
  const [errorMessage, setErrorMessage] =React.useState(null)

  const { addContact, configValue, locationConfigNumber, locationConfigValue } =React.useContext(BusinessContext);
  const { cartItems, clearCart, ageConfirmed, dateOfBirth, pendingOrder, setPendingOrder,
    addOrderHistory, submitOrder, totalItemsCost, applyDiscount,
    isDiscountActive, discountMessage } =React.useContext(CartContext);

  const { tr, trmap /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  const whatsappButton = (phone) => {

    if (phone.startsWith('+')) phone = phone.slice(1)
    if (phone.startsWith('57') === false)
      phone = '57' + phone

    phone = phone.replace(/[^0-9]/g, '')

    let text = `%F0%9F%91%8B%20Hola%20%0ADeseo%20hablar%20sobre%20mi%20pedido%3A%0A`
    let prefix = "https://wa.me/" + phone
    return (
      <a href={prefix + '/?text=' + text} target="_blank" rel="noopener noreferrer" >
        <i className="icofont icofont-whatsapp icofont-2x"
          style={{
            paddingRight: 5,
            color: 'white'
          }}
        ></i>
      </a>

    )
  }

  const _paidOrderButton = (phone, id) => {

    if (phone.startsWith('+')) phone = phone.slice(1)
    if (phone.startsWith('57') === false)
      phone = '57' + phone

    phone = phone.replace(/[^0-9]/g, '')

    let text = `%F0%9F%91%8B%20Hola%2C%20mi%20pedido%20%5B${id}%5D%20en%20ZONO%20esta%20pagado%20con%20referencia%20%3A%20`
    let prefix = "https://wa.me/" + phone

    return (
      <a href={prefix + '/?text=' + text} target="_blank" rel="noopener noreferrer" >
        <div className="align-items-center" style={{ marginLeft: 0, marginRight: 2, height: 50, display: 'flex', justifyContent: 'space-evenly' }} >
          <div style={{ paddingTop: 5 }} className="font-weight-bold ">

            <i className="fa fa-whatsapp fa-2x"
              style={{
                paddingRight: 5,
                color: 'black'
              }}
            ></i>
          </div>
          <div className=" font-weight-bold align-items-center" style={{ color: 'black', }}>Enviar comprobante</div>

        </div>
      </a>

    )
  }

  const _iconForPaymentMethod = () => {
    //console.log("payment", paymentMethod, bankName, methodData)
    if (paymentMethod === 'Transfer' || paymentMethod === 'Transferencia') {
      if (bankName && bankName === 'Bancolombia') {
        return (
          <div><img src="/img/bank/bancolombia.png" style={{ maxWidth: '90%' }} alt="Bancolombia" /></div>
        )
      }
      if (bankName && bankName === 'Davivienda') {
        return (
          <div><img src="/img/bank/davivienda.png" style={{ maxWidth: '90%' }} alt="Davivienda" /></div>
        )
      }
      return (
        <div><img src="/images/transfer.png" height={40} alt="Transfer" /></div>
      )
    } else if (paymentMethod === 'Nequi') {
      return (
        <div><img src="/images/nequi.png" height={50} alt="Nequi" /></div>
      )
    } else if (paymentMethod === 'Cash' || paymentMethod === 'Efectivo') {
      return (
        <div><img src="/images/cash.png" height={50} alt="Cash" /></div>
      )
    } else if (paymentMethod === 'Daviplata') {
      return (
        <div><img src="/images/daviplata.png" height={50} alt="Daviplata" /></div>
      )
    }

  }

  const _paymentInfo = (order) => {

    console.log("payment info", paymentMethod, methodData, order)

    if (paymentMethod !== 'Cash' && paymentMethod !== 'Efectivo') {
      return (
        <div className="payment-info-container">
          <div className="row align-items-center" style={{ marginLeft: 0, marginRight: 2, marginBottom: 20 }} >
            <div className="col-sm-12   font-weight-bold" >
              <div className=" centered px-2" style={{ backgroundColor: '#fff', color: 'black', borderRadius: 12 }}>
                <span>{_iconForPaymentMethod()}</span>
                <span style={{ fontSize: 26, paddingLeft: 20, margin: 'auto' }}>{methodData || ''}</span>
              </div>
            </div>
          </div>

          <div className="row align-items-center" style={{ marginLeft: 0, marginRight: 2, marginBottom: 20 }} >
            <div style={{}} className="col-sm-12  font-weight-bold">
              <div style={{ backgroundColor: '#F1AD3E', borderRadius: 12, }} className="font-weight-bold">
                {_paidOrderButton(menu.Location.phone, order.orderNumber)}</div>
            </div>
          </div>

        </div>

      )
    }
    return (
      <div className="row align-items-center" style={{ marginLeft: 0, marginRight: 2, marginBottom: 20, maxHeight: 90 }} >
        <div style={{ backgroundColor: '#fff', color: 'black', borderRadius: 12, paddingLeft: 0, width: '100%' }}
        className="centered font-weight-bold">{_iconForPaymentMethod()}
          <span className="font-weight-bold">{tr(paymentMethod)}</span></div>
      </div>
    )

  }

  const trackingButton = (phone, Bcolor, img, id) => {

    if (phone.startsWith('+')) phone = phone.slice(1)
    if (phone.startsWith('57') === false)
      phone = '57' + phone

    phone = phone.replace(/[^0-9]/g, '')

    let text = `%F0%9F%91%8B%20Hola%2C%20quiero%20hacer%20seguimiento%20de%20mi%20pedido%20%5B${id}%5D%20en%20ZONO`
    let prefix = "https://wa.me/" + phone
    return (
      <div style={{
        margin: 10
      }}>
        <a href={prefix + '/?text=' + text} target="_blank" rel="noopener noreferrer"

          className="btn btn-lg row centrar" style={{ backgroundColor: Bcolor, color: "white", margin: 0, padding: "10px" }}
        >
          <i className={img}
            style={{ color: 'white', padding: "10px" }}
          ></i>
          {tr("Track my order")}
          <i className="icofont-long-arrow-right" />

        </a>
      </div>
    )
  }

  const _deliveryDataDisplay = () => {

    const iconForTitle = (title) => {
      switch (title) {
        case tr("Home"): return "home";
        case tr("Work"): return "briefcase";
        default: return 'building-alt'
      }
    }
    if (deliverType === 'delivery') {
      return <DisplayAddressCard
        boxclassName="border border-success"
        title={deliveryData.title}
        icoIcon={iconForTitle(deliveryData.title)}
        iconclassName='icofont-3x'
        address={deliveryData}
        boxClass={''}
      />
    } else if (deliverType === 'takeaway') {
      return (
        <div id="takeaway-delivery" className=" delivery-item"    >

          <div className="row">
            <div className="col centered">
              <img src="/images/takeaway.png" alt="" />
            </div>
          </div>

          <div className="row">
            <div className="col centered">
              {tr("Takeaway")}
            </div>
          </div>
        </div>
      )
    } else if (deliverType === 'table') {
      return (
        <div id="table-delivery" className="delivery-item">
          <div className="row">
            <div className="col centered">
              <img src="/images/table-service.png" alt="" />
            </div>
          </div>

          <div className="row">
            <div className="col centered" style={{
              fontSize: '1.5em'
            }}>
              {tr("Table")} {deliveryData.tableNum}
            </div>
          </div>

        </div>
      )
    }

  }

  const _fixupPhone = (phone) => {
    if (phone == null) {
      return ""
    }
    if (phone.startsWith('+')) return phone;

    if (phone.startsWith('3') && phone.length === 10) return `+57${phone}`

    return `+${phone}`
  }

 React.useEffect(() => {

    if (checkoutData) {

      //console.log("has checkoutData", checkoutData)

      let deliveryData = checkoutData.deliveryData
      let paymentMethod = checkoutData.paymentMethod

      let deliverType = checkoutData.deliverType
      let methodData = checkoutData.methodData
      let bankName = checkoutData.bankName

      let packingCost = deliverType == "table" ? 0 : locationConfigNumber(business.Configs, menu.Location.id, "packingCost", null)

      setTotalWithDelivery(locationConfigValue(business.Configs, menu.Location.id, "totalWithDelivery", "true") === "true")

      setDeliverType(deliverType)
      setDeliveryData(deliveryData)
      setPaymentMethod(paymentMethod)
      SetMethodData(methodData)
      setBankName(bankName)

      // copy the discounted cost to the delivery data
      deliveryData.discountedCost = checkoutData.discountedCost

      // get the delivery charge range from business configs
      /* eslint-disable react-hooks/exhaustive-deps */
      //console.log("menu business",business)
      setChargeRange(configValue(business, "deliveryChargeRange", null))
      /* eslint-disable react-hooks/exhaustive-deps */
      setPackingCost(packingCost)

      //console.log("data:",  deliveryData ,paymentMethod )
      let po = localStorage.getItem('pendingOrder')

      //console.log("submit order:",        orderSubmitted, pendingOrder, menu, deliveryData, paymentMethod, cartItems.length      )

      if (!po && !orderSubmitted && !pendingOrder && menu && paymentMethod && cartItems && cartItems.length > 0) {

        /* eslint-disable react-hooks/exhaustive-deps */
        //setMinimumOrderValue(configNumber(business, "minimumOrderValue", 0))
        /* eslint-disable react-hooks/exhaustive-deps */
        //setMinimumOrderMessage(configValue(business, "minimumOrderMessage", null))

        // submit the order with the data from the localStorage and CartContext

        deliveryData.phone = _fixupPhone(deliveryData.phone)

        setErrorMessage(null)

        submitOrder(menu, deliverType, deliveryData, paymentMethod, cartItems, packingCost, (data) => {
          setOrderSubmitted(true)

          // add the order contact
          addContact(deliveryData, menu, ageConfirmed, dateOfBirth)

          //let d = new Date()

          //let d = new Date()

          // add the order to the previous orders
          // data is the order ID returned from the API
          let order = {
            id: data.id,  orderNumber: data.orderNumber || data.id,
            Business: business,
            items: cartItems.map(item => ({
              product_id: item.id,
              name: item.name,
              description: item.description,
              price: item.price,
              quantity: item.quantity,
              CategoryName: item.Category?.name || 'Unknown',
            })),
            totalcost: checkoutData.discountedCost || totalItemsCost,
            status: 'pending',
            tstamp: new Date().toISOString(),
            deliverType: deliverType,
            destination: deliveryData.destination || deliveryData.city,
            paymentMethod: paymentMethod,
          }
          //console.log("add order history", order)
          addOrderHistory(order)
          
        }, (error) => {
          console.log("error", error)

          if (error.includes("menu is not available to take orders")) {
            setErrorMessage(tr("The menu is not available to take orders at this time"))
          } else {
            setErrorMessage(error)
          }
        })

        // add window stepper

      } else {
        setOrderSubmitted(true)

        if (po != null) {
          let order = JSON.parse(po)
          console.log("pending order", order)
          setPendingOrder(order)
        }
      }
    } else {
      window.location.href = "/"
    }

  }, [])

  let order = pendingOrder || { cartItems: [], items: [] }

  let itemsInCart = order.items

  const _getTotalCostIncPacking = () => {
    //console.log("_getTotalCostIncPacking", pendingOrder, itemsInCart)

    if (pendingOrder) {
      return pendingOrder.itemscost + packingCost
    }
    if (!deliverType) {
      return totalItemsCost(itemsInCart)
    }
    if (deliverType !== "table") {
      return totalItemsCost(itemsInCart) + packingCost
    }
    return totalItemsCost(itemsInCart)
  }

  const _deliveryChargeElement = () => {
    if (deliverType === "delivery" && deliveryPrice != null && parseInt(deliveryPrice) > 0) {
      let delFee = parseInt(deliveryPrice)
      totalCost += delFee
      return <>
        <p className="mb-1">{tr("Delivery Fee")}
          <span className="float-right text-dark">$ {deliveryPrice}</span>
        </p>

        <h6 className="font-weight-bold mb-0">{tr("TO PAY")} <span className="float-right">${totalCost}</span></h6>
      </>
    }

    return <>
      {deliveryChargeRange && deliverType === "delivery" &&
        <p className="mb-1">{tr("Estimated Delivery Fee")}
          <span className="text-info ml-1">
              <i className="icofont-info-circle" title={tr("Actual cost varies")} />
            </span>
          <span className="float-right text-dark">{deliveryChargeRange}</span>
        </p>
      }

      <hr />
      <h6 className="font-weight-bold mb-0">{tr("TO PAY")} <span className="float-right">${totalCost}</span></h6>

      {deliveryChargeRange && packingCost && deliverType === "delivery" &&
        <div>&nbsp;</div>
      }

      {deliveryChargeRange && deliverType === "delivery" &&
        <span className="float-right"> + {deliveryChargeRange}</span>
      }
    </>
  }

  const barrioCost = deliveryData && deliveryData.barrioCost ? deliveryData.barrioCost : 0
  const distanceCost = deliveryData && deliveryData.distanceCost ? deliveryData.distanceCost : 0

  const totalWithDiscountElement = () => {
    let newCost = applyDiscount(order.itemscost, menu)

    console.log("totalWithDiscountElement", order.itemscost, packingCost, totalWithDelivery, newCost, barrioCost, distanceCost)

    if (deliverType && deliverType !== "table") {
      //return discountedCostElement(totalItemsCost(cartItems), packingCost || 0, menu, barrioCost)
      if (totalWithDelivery == true && deliverType === "delivery") {
        return <h6 className="font-weight-bold mb-0 text-black totalWithDiscountElement">
          {tr("TO PAY")} <span className="float-right discounted-cost">{formatPrice(newCost + packingCost + (barrioCost || distanceCost || 0))}</span></h6>
      } else {
        return <h6 className="font-weight-bold mb-0 text-black totalWithDiscountElement">
          {tr("TO PAY")} <span className="float-right discounted-cost">{formatPrice(newCost + packingCost)}</span></h6>
      }
    }

    return <h6 className="font-weight-bold mb-0 text-black totalWithDiscountElement">
      {tr("TO PAY")} <span className="float-right discounted-cost">{formatPrice(newCost)}</span></h6>
  }


  const deliveryCostElement = () => {
    if (deliverType !== "delivery" || totalWithDelivery == true) return <></>

    let noDeliveryCosts = menu.Location.flags && menu.Location.flags.includes("noDeliveryCharge")

    if (noDeliveryCosts === true) {
      return <></>
    }

    if (barrioCost && barrioCost > 0) {
      return <span className="float-right text-dark"> + {formatPrice(barrioCost)}</span>
    }

    if (distanceCost && distanceCost > 0) {
      return <span className="float-right text-dark"> + {formatPrice(distanceCost)}</span>
    }

    if (deliveryChargeRange) {
      return <span className="float-right text-dark"> + {deliveryChargeRange}</span>
    }

    return <></>
  }

  const estimatedOrCalculatedDeliveryCost = () => {
    if (deliverType !== "delivery") return <></>

    let noDeliveryCosts = menu.Location.flags && menu.Location.flags.includes("noDeliveryCharge")

    if (noDeliveryCosts === true) {
      return <></>
    }

    if (barrioCost && barrioCost > 0) {
      return <p className="mb-1">{tr("Calculated Delivery Fee")}
        <span className="float-right text-dark">{formatPrice(barrioCost)}</span>
      </p>
    }

    if (distanceCost && distanceCost > 0) {
      return <p className="mb-1">{tr("Estimated Delivery Fee")}
        <span className="text-info ml-1">
              <i className="icofont-info-circle" title={tr("Actual cost varies")} />
            </span>
        <span className="float-right text-dark">{formatPrice(distanceCost)}</span>
      </p>
    }

    if (deliveryChargeRange) {
      return <p className="mb-1">{tr("Estimated Delivery Fee")}
        <span className="text-info ml-1">
              <i className="icofont-info-circle" title={tr("Actual cost varies")} />
            </span>
        <span className="float-right text-dark">{deliveryChargeRange}</span>
      </p>
    }
  }

  let totalCost = _getTotalCostIncPacking()

  //console.log("Thanks", order, itemsInCart, totalCost, deliveryPrice, packingCost, deliverType)

  if (orderSubmitted) {
    return (
      <section className="section pt-5 pb-5 osahan-not-found-page">
        <div className="container" >
          <div className="row" >
            <div className="col-md-8 text-center pb-5" style={{ paddingBottom: "3rem" }}>
              <div className="row align-items-center"  style={{ padding: "10px" }}>
                <div className="col">
                  <img className="img-thanks col-4 col-sm-12" src="/img/thanks.png" alt="404" />
                </div>

                <div className="col" style={{ marginBottom: "10px" }}>
                  <span>{tr("Your order has been placed")}</span>
                </div>
              </div >

              <div className="row order-progress-container">
                {/* order tracking stepper */}
                <OrderProgress order={order} menu={menu} setDeliveryPrice={(price) => {
                  console.log("delivery price", price)
                  setDeliveryPrice(price)
                }}
                  doNewOrder={() => {
                    // clear the order and cart items
                    //console.log("do new order")
                    clearCart()
                    localStorage.removeItem('pendingOrder')
                    localStorage.removeItem('paymentMethod')
                    setStage("detail")
                  }}
                />

              </div>

            </div>


            <div className="col-md-4">
              <div className="generator-bg rounded shadow-sm mb-4 p-4 osahan-cart-item">
                <div className="d-flex mb-1 osahan-cart-item-profile">
                  <img fluid className="mr-3 rounded-pill" alt="osahan" src={business.photo || "/img/2.jpg"} />
                  <div className="d-flex flex-column">
                    <h6 className="mb-1 text-white">{business.name}</h6>
                    <p className="mb-1 text-white"><i className="icofont-location-pin" /> {menu.Location.address}, {menu.Location.city}</p>
                    <div className="mb-0 text-white row align-items-center" style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: '1rem'
                    }}>
                      <div className='col-3 pr-0 align-end'>
                        {whatsappButton(menu.Location.phone)}
                      </div>
                      <div className='col pl-2'>
                        {menu.Location.phone}
                      </div>
                    </div>
                  </div>

                </div>

                <div className="row align-items-center">
                  <div className="col d-flex justify-content-center">

                    {trackingButton("573246575352", "#25D366", "icofont icofont-whatsapp icofont-2x", order.id)}
                  </div>

                </div>

                <div className="bg-white rounded shadow-sm mb-2">
                  {itemsInCart.map((item, index) => {

                    //console.log("Thanks item", item)
                    return <CheckoutItem
                      key={'cart_item_' + index}
                      itemName={item.name}
                      cartItem={item}
                      price={item.chosenPrice || item.price}
                      priceUnit="$"
                      id={item.id}
                      quantity={item.quantity}
                      show={true}
                      minValue={0}
                      maxValue={7}
                      formatPrice={formatPrice}

                    />
                  }
                  )}

                </div>

                { /* promo code */}

                <div className="mb-2 bg-white rounded p-2 clearfix">
                  { /* item cost */}
                  <p className="mb-1">{tr("Item Total")} <span className="float-right text-dark">{formatPrice(order.itemscost)}</span></p>

                  {packingCost && deliverType && deliverType !== "table" &&
                    <p className="mb-1">{tr("Packaging charge")}
                        <span className="text-info ml-1">
                          <i className="icofont-info-circle" title={tr("Additional charges for packaging material")} />
                        </span>
                      <span className="float-right text-dark">{formatPrice(packingCost)}</span>


                    </p>
                  }

                  {estimatedOrCalculatedDeliveryCost()}

                  <hr />

                  {/* total discount*/}
                  <p className="align-right mb-1 text-dark discountMessage">
                    <span >{discountMessage(menu)}</span>
                  </p>

                  {totalWithDiscountElement()}

                  {deliveryCostElement()}
                </div>

              </div>

              <div style={{
                padding: 5
              }}>

                <h6 className="payment-info-title centered">{tr("Payment Method")}</h6>

                {_paymentInfo(order)}

                <h6>{tr("Deliver To")}</h6>

                <div className="p-0" style={{ backgroundColor: '#fff' }}>
                  {_deliveryDataDisplay()}
                </div>

              </div>
              <div className="pt-2"></div>


            </div>
            <div className="col-md-4 text-center pt-5 btn-show-goHome">
              <div className="btn btn-primary btn-lg"
                onClick={() => {
                  // clear the order and cart items
                  clearCart()
                  localStorage.removeItem('pendingOrder')
                  localStorage.removeItem('paymentMethod')
                  setStage("detail")
                }}>{tr("GO HOME")}</div>
            </div>
          </div >
        </div >
      </section>
    );
  }

  if (errorMessage) {
    return (
      <section className="section pt-5 pb-5 osahan-not-found-page">
        <div className="container" >
          <div className="row" >
            <div className ="col-md-12 text-center pt-5 pb-5">
              <img className="img-fluid" src="/img/logo.png" alt="thanks" />
              <h1 className="mt-2 mb-2">{tr("Error")}</h1>
              <p className="mb-5">{errorMessage} </p>

              <p>Por favor contactar {business.name}</p>
              <p> {menu.Location.phone}</p>
            </div>
          </div >
        </div >
      </section>
    );
  }

  return (
    <section className="section pt-5 pb-5 osahan-not-found-page">
      <div className="container" >
        <div className="row" >
          <div className ="col-md-12 text-center pt-5 pb-5">
            <img className="img-fluid" src="/images/zono-smile.png" alt="thanks" />
            <h1 className="mt-2 mb-2">{tr("Submitting your order")}</h1>
            <p className="mb-5">{tr("Please wait")} </p>
          </div>
        </div >
      </div >
    </section>
  );
}

export default Thanks;